module.exports = __webpack_public_path__ + "static/media/2.78c5bd52.svg";